import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const KEY = "wtd-cookie-consent-v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) {
      // slight delay to avoid flashing on first paint
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[70] rounded-2xl bg-[#0e0e12] border border-white/12 shadow-2xl p-5"
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <div className="font-display text-white text-base leading-tight mb-1">Cookies on WTD</div>
          <div className="text-white/60 text-sm leading-relaxed">
            We use essential cookies to run this site plus a few for analytics.
            You can accept or decline non-essential ones any time.{" "}
            <Link to="/cookies" className="text-[#1F5EFF] hover:text-white underline">Read cookie policy</Link>.
          </div>
        </div>
        <button
          onClick={() => accept("dismiss")}
          className="text-white/40 hover:text-white p-1 -m-1"
          aria-label="Close"
          data-testid="cookie-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <button
          onClick={() => accept("all")}
          data-testid="cookie-accept-all"
          className="flex-1 px-5 py-2.5 rounded-full bg-[#1F5EFF] hover:bg-white hover:text-black text-white text-sm font-semibold transition-colors"
        >
          Accept all
        </button>
        <button
          onClick={() => accept("essential")}
          data-testid="cookie-essential-only"
          className="flex-1 px-5 py-2.5 rounded-full border border-white/15 text-white/80 hover:text-white hover:bg-white/5 text-sm transition-colors"
        >
          Essential only
        </button>
      </div>
    </div>
  );
}
